const urlPattern = /^https?:\/\//i;

export const isAbsoluteUrl: (url: string) => boolean = (url) => urlPattern.test(url);
